interface MessageFilter {
  message: string;
  expectedContent: string[];
}

const messageFilters : MessageFilter[] = [
  {
    message: 'Extraneous non-props attributes',
    expectedContent: ['<Builder']
  }
];

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.warnHandler = (msg, vm, trace) => {
    const hasFilteredMessage = messageFilters.some(filter => {
      const matchesMessage = msg.indexOf(filter.message) === 0;
      const matchesContent = filter.expectedContent.some(content => msg.includes(content));
      return matchesMessage && matchesContent;
    });

    if (!hasFilteredMessage) {
      console.warn(msg, trace);
    }
  }
})